export default "__VITE_ASSET__CQrBaPEZ__"